module.exports = __webpack_public_path__ + "static/media/icon-mateEdu.73b30db5.svg";